export default "__VITE_ASSET__Bc5l$AN___"